import { ValidationSchemaType } from 'hooks/useForm';
import { Website } from '../types/dtos';

export const WEBSITE_INITIAL_FIELDS: Website = {
    name: '',
    domain: '',
    description: '',
    companyId: '',
    homeType: 'TYPE1',
    menuType: 'TYPE1',
    articleType: 'TYPE1',
};

export const WEBSITE_FIELDS_SCHEMA: ValidationSchemaType<Website> = {
    name: {
        required: true,
        maxLength: 100,
    },
    domain: {
        required: true,
        maxLength: 100,
        type: 'domain',
    },
    description: {
        maxLength: 100,
    },
    companyId: {
        required: true,
    },
    homeType: {
        required: true,
    },
    menuType: {
        required: true,
    },
    articleType: {
        required: true,
    },
};
